const domainWorkerTypeRuleEn = {
  common: {
    workerType: {
      // TODO: common.workerType に統一したい
      BOARD_MEMBER: 'Board Member',
      COLLABORATOR: 'Collaborator',
      CONTRACTOR: 'Contractor',
      EMPLOYEE: 'Employee'
    }
  },
  individualCondition: {
    exclude: 'Exclude',
    excludeNone: '-',
    include: 'Include',
    includeNone: '-'
  },
  individualHeader: {
    description: 'You can set rules for individuals when specifying privileged administrators separately or excluding them individually from the rules specified above.',
    title: 'Individual'
  },
  ruleAccordionRadioButtonGroup: {
    settingType: {
      ALL: 'Assign to all',
      CUSTOM: 'Custom Rule',
      NO_ONE: 'Assign to no one'
    }
  },
  ruleHeader: {
    description: 'You can set rules for each employee or contractor. It is also possible to configure settings by specifying departments or job roles.',
    title: 'Worker Type'
  }
};
export default domainWorkerTypeRuleEn;